// @Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Third party
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TabsModule } from 'ngx-bootstrap/tabs';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_FORMATS,
  OwlDateTimeIntl,
  OWL_DATE_TIME_LOCALE
} from 'ng-pick-datetime';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NgSelectModule } from '@ng-select/ng-select';
import { PrettyJsonModule } from 'angular2-prettyjson';
import { Ng2FileInputModule, Ng2FileInputComponent } from 'ng2-file-input';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

// Local components
import { LoaderComponent } from './loader/loader.component';
import * as directives from './directives';
import { DynamicFormComponent, DynamicFormControlComponent } from './dynamic-form';
import { ConfirmComponent } from './confirm/confirm.component';
import { DateFormatPipe } from './pipes/moment/date-format.pipe';
import { DateCalendarPipe } from './pipes/moment/date-calendar.pipe';
import { UrlSanitizerPipe } from './pipes/url-sanitizer.pipe';
import { EmptyComponent } from './empty/empty.component';
import { ModalTableComponent } from './modal-table/modal-table.component';
import { MY_NATIVE_FORMATS, DefaultIntl } from './util/config-default-datetimepicker';
import * as componetTable from './component-table';
import { RefactorDynamicFormComponent } from './refactor-dynamic-form/refactor-dynamic-form.component';
import { ControlMessagesComponent } from './control-messages/control-messages.component';
import { LoadInformationExcelComponent } from './load-information-excel/load-information-excel.component';
import { ModalSelectComponent } from './modal-select/modal-select.component';
import { RefactoryMasterTableComponent } from './refactory-master-table/refactory-master-table.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PrettyJsonModule,
    BsDropdownModule,
    ModalModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BsDatepickerModule,
    TypeaheadModule,
    Ng2SmartTableModule,
    NgSelectModule,
    Ng2FileInputModule,
    ScrollToModule,
    TabsModule.forRoot(),
  ],
  entryComponents: [
    componetTable.CustomEditorComponent,
    componetTable.ButtonViewComponent,
    componetTable.ButtonDownloadReviewComponent,
    componetTable.ButtonDownloadComponent,
    componetTable.ButtonViewFormDynamicComponent,
    componetTable.ButtonsAccionDynamicFormsTableComponent,
    componetTable.RangeRefactoryTableDynamicComponent,
    componetTable.ButtonsAssociateDocumentComponent,
    componetTable.ButtonsDeleteComponent,
    componetTable.CalendarRefactoryTableDynamicComponent,
    componetTable.DateTimerRefactoryTableDynamicComponent,
    componetTable.RangeDateRefactoryTableDynamicComponent,
    componetTable.RangeTimerRefactoryTableDynamicComponent,
    componetTable.TimerRefactoryTableDynamicComponent,
    componetTable.CoordinateDynamicFormsComponent,
    componetTable.ButtonsActionsTableComponent,
    componetTable.CheckTableComponent,
    componetTable.RadioButtonsCheckListComponent,
    componetTable.StatusTramiteComponent,
    componetTable.DateStringComponent,
    componetTable.InfoRadicationDocComponent,
    componetTable.DynamcColumnComponent,
    componetTable.NameUserAssignmentComponent,
    componetTable.ButtonDownloadDeleteComponent,
    componetTable.RowSelectionCheckboxComponent,
    componetTable.InputTableComponent,
    componetTable.ButtonDownloadCheckComponent,
    componetTable.ThousandsSeparatorNumberFormatComponent,
    componetTable.LabelNgSelectDynamicTableComponent,
    Ng2FileInputComponent,
    DynamicFormComponent
  ],
  declarations: [
    LoaderComponent,
    directives.ClickStopPropagationDirective,
    DynamicFormComponent,
    DynamicFormControlComponent,
    ConfirmComponent,
    EmptyComponent,
    DateFormatPipe,
    DateCalendarPipe,
    UrlSanitizerPipe,
    ModalTableComponent,
    componetTable.CustomEditorComponent,
    componetTable.ButtonViewComponent,
    componetTable.ButtonDownloadReviewComponent,
    componetTable.ButtonDownloadComponent,
    componetTable.ButtonViewFormDynamicComponent,
    componetTable.ButtonsAccionDynamicFormsTableComponent,
    RefactorDynamicFormComponent,
    componetTable.RangeRefactoryTableDynamicComponent,
    componetTable.ButtonsAssociateDocumentComponent,
    componetTable.ButtonsDeleteComponent,
    ControlMessagesComponent,
    componetTable.CalendarRefactoryTableDynamicComponent,
    componetTable.DateTimerRefactoryTableDynamicComponent,
    componetTable.RangeDateRefactoryTableDynamicComponent,
    componetTable.RangeTimerRefactoryTableDynamicComponent,
    componetTable.TimerRefactoryTableDynamicComponent,
    componetTable.CoordinateDynamicFormsComponent,
    componetTable.ButtonsActionsTableComponent,
    componetTable.CheckTableComponent,
    componetTable.RadioButtonsCheckListComponent,
    componetTable.StatusTramiteComponent,
    componetTable.DateStringComponent,
    componetTable.InfoRadicationDocComponent,
    componetTable.DynamcColumnComponent,
    componetTable.NameUserAssignmentComponent,
    componetTable.ButtonDownloadDeleteComponent,
    componetTable.RowSelectionCheckboxComponent,
    componetTable.InputTableComponent,
    componetTable.ButtonDownloadCheckComponent,
    componetTable.ThousandsSeparatorNumberFormatComponent,
    componetTable.LabelNgSelectDynamicTableComponent,
    LoadInformationExcelComponent,
    ModalSelectComponent,
    RefactoryMasterTableComponent,
    directives.CustomMinDirective,
    directives.CustomMinEqualDirective,
    directives.CustomMaxDirective,
    directives.CustomMaxEqualDirective,
    directives.CustomDecimalMaxDirective,
    directives.ThousandsSeparatorDirective,
    directives.FormatNumberDirective,
    ChangePasswordComponent,
  ],
  exports: [
    LoaderComponent,
    directives.ClickStopPropagationDirective,
    DynamicFormComponent,
    ConfirmComponent,
    EmptyComponent,
    ModalTableComponent,
    DateFormatPipe,
    DateCalendarPipe,
    UrlSanitizerPipe,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    Ng2SmartTableModule,
    componetTable.CustomEditorComponent,
    componetTable.ButtonViewComponent,
    componetTable.ButtonViewFormDynamicComponent,
    NgSelectModule,
    RefactorDynamicFormComponent,
    componetTable.RangeRefactoryTableDynamicComponent,
    componetTable.ButtonsAssociateDocumentComponent,
    componetTable.ButtonsDeleteComponent,
    ControlMessagesComponent,
    componetTable.CalendarRefactoryTableDynamicComponent,
    componetTable.DateTimerRefactoryTableDynamicComponent,
    componetTable.RangeDateRefactoryTableDynamicComponent,
    componetTable.RangeTimerRefactoryTableDynamicComponent,
    componetTable.TimerRefactoryTableDynamicComponent,
    componetTable.CoordinateDynamicFormsComponent,
    componetTable.ButtonsActionsTableComponent,
    componetTable.CheckTableComponent,
    componetTable.RadioButtonsCheckListComponent,
    componetTable.StatusTramiteComponent,
    componetTable.DateStringComponent,
    componetTable.InfoRadicationDocComponent,
    componetTable.DynamcColumnComponent,
    componetTable.NameUserAssignmentComponent,
    componetTable.ButtonDownloadDeleteComponent,
    componetTable.RowSelectionCheckboxComponent,
    componetTable.InputTableComponent,
    componetTable.ButtonDownloadCheckComponent,
    componetTable.ThousandsSeparatorNumberFormatComponent,
    componetTable.LabelNgSelectDynamicTableComponent,
    LoadInformationExcelComponent,
    ModalSelectComponent,
    directives.CustomMinDirective,
    directives.CustomMaxDirective,
    directives.CustomDecimalMaxDirective,
    directives.ThousandsSeparatorDirective,
    directives.FormatNumberDirective,
    PrettyJsonModule,
    RefactoryMasterTableComponent,
    TabsModule,
    ChangePasswordComponent
  ],
  providers: [
    // idioma de la libreria NgPickDateTime
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'es-CO' },
    // formato de fechas libreria NgPickDateTime
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS },
    // default de variables de la libreria
    { provide: OwlDateTimeIntl, useValue: DefaultIntl },
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts